import styled from "styled-components";
import colours from "styles/colours";
import fonts from "styles/fonts";

export const StyledInput = styled.input`
  display: block;
  width: 100%;
  border: 1px solid ${colours.elexonBlue};
  border-radius: 200px;
  padding: 0.65rem 1rem;
  font-size: ${fonts.small};

  &:focus,
  &:active,
  &:hover {
    outline: none;
    box-shadow: none;
    border: 1px solid ${colours.elexonBlue};
  }

  &.invalid {
    border: 1px solid ${colours.elexonRed};
    padding-left: 33px;
  }
`;
